import React from 'react'
import {Link} from 'react-router-dom'
import { withComponentLabel } from '../../utils/debug'

const HamburgerMenuSelect = ({
  target,
  label,
  style = 'border-b-orange-300 border-b-2 flex items-center',
  icon,
}) => {
  return (
    <Link to={target} className={style}>
      {icon}
      <span className='ml-2'>{label}</span>
    </Link>
  )
}

export default withComponentLabel(HamburgerMenuSelect, 'HamburgerMenuSelect')
